import { render, staticRenderFns } from "./HSCodesForm.vue?vue&type=template&id=00757828&"
import script from "./HSCodesForm.vue?vue&type=script&lang=js&"
export * from "./HSCodesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports